var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"card-section pb-5"},[_c('PaymentInfo',{attrs:{"showDetails":_vm.showDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }